import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground overflow-x-hidden">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: 'hsl(240, 4%, 10%)',
            color: 'hsl(0, 0%, 98%)',
            border: '1px solid hsl(240, 4%, 16%)',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
